var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * 多语言相关函数
 */
import { isWeChat, isFusionBankApp, setCookie } from '@tencent/vb-web-base-core';
// TODO 抽离到vb
import { appInfoUtil, webAdaptor } from '@tencent/vb-app-bridge';
import Cookie from 'js-cookie';
import { langCookieKey, LanguageList, OfficialLanguageMap } from './config';
// 内部支持的几种语言的标准key
// 从url获取语言
/**
 * 从url获取指定语言key
 * 说明：
 * url参数key 为lang
 * lang的枚举值为 'en-GB', 'zh-CN', 'zh-HK' 不在枚举中则返回空串
 */
var getLangFromUrl = function () {
    var result = '';
    var langPattern = /lang=([-a-z]+)/i;
    var match = location.search.match(langPattern);
    if (match) {
        result = match[1];
    }
    if (OfficialLanguageMap[result]) {
        result = OfficialLanguageMap[result];
    }
    // 必须是标准支持的lang key中的一个
    return LanguageList.indexOf(result) > -1 ? result : '';
};
/**
 * 获取当前语言
 * todo
 * 优先级：url > 用户设置（微信=fusion bank app > 系统） > 兜底
 */
var getLang = function (defaultLang) {
    if (defaultLang === void 0) { defaultLang = 'en-GB'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var langFromUrl, langFromNavigator, lang, langLowerCase;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    langFromUrl = getLangFromUrl();
                    if (langFromUrl) {
                        return [2 /*return*/, (langFromUrl || defaultLang)];
                    }
                    langFromNavigator = navigator.language || navigator.userLanguage;
                    langFromNavigator = langFromNavigator.replace('_', '-');
                    // 微信中页面获取当前微信的语言设置
                    if (isWeChat) {
                        lang = (navigator.userAgent.split(' ').find(function (i) { return i.indexOf('Language') > -1; }) || '').replace('Language/', '');
                        // 微信中多语言连接符号是下划线 统一转成中划线
                        lang = lang.replace('_', '-');
                        // 处理一下台湾繁体
                        if (lang === 'zh-TW') {
                            return [2 /*return*/, 'zh-HK'];
                        }
                        if (LanguageList.indexOf(lang) > -1) {
                            return [2 /*return*/, lang];
                        }
                        langFromNavigator = lang;
                    }
                    if (!isFusionBankApp) return [3 /*break*/, 2];
                    webAdaptor();
                    return [4 /*yield*/, appInfoUtil.getAppLanguage()];
                case 1:
                    langFromNavigator = _a.sent();
                    _a.label = 2;
                case 2:
                    langLowerCase = langFromNavigator.toLowerCase();
                    // 获取到系统级别的语种的大小写规范不同，这里统一转换
                    if (LanguageList.indexOf(langFromNavigator) === -1) {
                        // 所有英文语言都用en-GB
                        if (langFromNavigator === 'en' || /^en-\w+/.test(langFromNavigator)) {
                            return [2 /*return*/, 'en-GB'];
                        }
                        // todo 应该把-前转换成小写，-后转换成大写
                        // todo zh 或者 zh 开头的语言，应该映射到什么语言呢？
                        if (langLowerCase === 'zh-hk' || langLowerCase === 'zh-tw') {
                            return [2 /*return*/, 'zh-HK'];
                        }
                        if (langLowerCase === 'zh-cn') {
                            return [2 /*return*/, 'zh-CN'];
                        }
                        return [2 /*return*/, defaultLang];
                    }
                    return [2 /*return*/, langFromNavigator];
            }
        });
    });
};
/**
 * 将语言写入cookie
 * @param lang
 */
var setLangCookie = function (lang) {
    // 某些情况下面, 微信浏览器会写入一个lang cookie , 而且设置的 domain 与我们不一致
    // 需要手动清理一下, 避免出现双重 lang cookie
    Cookie.remove(langCookieKey);
    setCookie(langCookieKey, lang);
};
export { getLang, setLangCookie };
